module.exports = __webpack_public_path__ + "img/ozturelogo.8bcf4335.png";